<template>
  <div>
    <BaseTitle :title="`${$t('content.use_template') + ' ' + templateName}`" />
    <v-row>
      <v-col cols="12" md="12">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-6">
              <form-group :name="$t('content.template_name')" :validator="$v.form.templateName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.templateName"
                    v-bind="attrs"
                    :label="$t('content.template_name')"
                    @input="$v.form.templateName.$touch()"
                    @blur="$v.form.templateName.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <v-card class="mb-8">
            <div class="pa-6">
              <v-row>
                <v-col md="12">
                  <form-group :name="$t('content.list_class')" :validator="$v.form.classroomId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-model="form.classroomId"
                        v-bind="attrs"
                        :items="listClass"
                        item-text="name"
                        item-value="classroomId"
                        :label="$t('content.list_class')"
                        @change="getStudent(form.classroomId)"
                        @input="$v.form.classroomId.$touch()"
                        @blur="$v.form.classroomId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <div class="d-flex justify-space-between">
                <div class="app-section-title mb-6">{{ $t('content.list_student') }}</div>
                <div class="app-section-title mb-6" style="color:#00bf63;">
                  {{ listStudent.length ? listStudent.length : 0 }} {{ $t('content.student') }}
                </div>
              </div>
              <v-data-table :headers="tableHeaderStudent" :loading="loading" :items="listStudent" hide-default-footer class="table-custom">
                <template #no-data> <NoData /></template>
              </v-data-table>
            </div>
          </v-card>

          <v-card class="mb-8" v-for="(data, index) in form.courses" :key="index">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">{{ data.categoryName }}</div>
            </div>
            <div class="pa-6">
              <form-group :name="$t('content.list_course')" :validator="$v.form.courses.$each.$iter[index].courses">
                <template slot-scope="{ attrs }">
                  <v-select
                    multiple
                    v-model="data.courses"
                    v-bind="attrs"
                    :items="data.listCourse"
                    :item-disabled="['isDisabled']"
                    item-text="name"
                    item-value="courseId"
                    :label="$t('content.list_course')"
                    persistent-hint
                    chips
                    offset-y
                    @input="$v.form.courses.$each.$iter[index].courses.$touch()"
                    @blur="$v.form.courses.$each.$iter[index].courses.$touch()"
                  >
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs" #default="{ active }" @click="actionFilter(data, index, item)">
                        <v-list-item-action>
                          <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-row no-gutters align="center"> {{ item.name }}</v-row>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </template>
              </form-group>
            </div>
          </v-card>

          <div class="d-flex justify-end align-center mt-8">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import NoData from '@/components/table/NoData';
export default {
  name: 'UseTemplateStudent',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        templateName: { required },
        classroomId: { required },
        courses: {
          $each: {
            courses: { required }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user'
    }),
    tableHeaderStudent() {
      return [
        { text: 'Student Name', value: 'fullName' },
        { text: 'NIS', value: 'identityNumber' }
      ];
    }
  },
  data: () => ({
    form: {
      analyticalTemplateStudentId: '',
      classroomId: '',
      courses: [],
      templateName: ''
    },
    templateName: '',
    listStudent: [],
    listClass: [],
    listCourse: [],
    loading: false,
    edit: false
  }),
  methods: {
    getData() {
      this.$store.dispatch('Analytical/getListTemplateStudentById', this.$route.params.idTemplate).then(ras => {
        ras.categories.forEach(data => {
          data.courseId = '';
          data.listCourse = [];
        });
        this.form.courses = ras.categories;
        this.form.analyticalTemplateStudentId = parseInt(this.$route.params.idTemplate);
        this.templateName = ras.templateName;
      });
    },
    actionFilter(course, index, item) {
      setTimeout(() => {
        this.dataFilterCourse(course, index, item.courseId);
      }, 400);
    },
    dataFilterCourse(course, index, item) {
      const arr = this.form.courses;

      let datas = this.form.courses.reduce((acc, row) => {
        acc.push(row.courses);
        return acc;
      }, []);
      let dataInput = [].concat(...datas);

      for (let i = 0; i < arr.length; i++) {
        for (let z = 0; z < arr[i].listCourse.length; z++) {
          if (i !== index) {
            if (dataInput.includes(arr[i].listCourse[z].courseId)) {
              if (arr[i].listCourse[z].isBack === true) {
                arr[i].listCourse[z].isDisabled = false;
              } else {
                arr[i].listCourse[z].isDisabled = true;
              }
            } else {
              arr[i].listCourse[z].isDisabled = false;
            }
          } else {
            if (arr[i].listCourse[z].courseId === item) {
              if (arr[i].listCourse[z].isBack === false) {
                arr[i].listCourse[z].isBack = true;
              } else {
                arr[i].listCourse[z].isBack = false;
              }
            }
          }
        }
      }
    },
    getClass() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getListClassStudent')
        .then(data => (this.listClass = data))
        .finally(() => (this.loadingLoad = false));
    },
    getStudent(id) {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/fetchListStudent', id)
        .then(data => (this.listStudent = data))
        .finally(() => {
          this.loadingLoad = false;
          this.getCourse(id);
        });
    },
    getCourse(id) {
      const payload = { id: id, classid: id };
      this.loadingLoad = true;
      this.$store
        .dispatch('CourseList/fetchList', payload)
        .then(data => {
          this.form.courses.forEach(datas => {
            datas.listCourse = data.map(item => {
              return {
                ...item,
                isDisabled: false,
                isBack: false
              };
            });
          });
        })
        .finally(() => (this.loadingLoad = false));
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }
      // function hasDuplicates(arr) {
      //   var counts = [];

      //   for (var i = 0; i <= arr.length; i++) {
      //     if (counts[arr[i]] === undefined) {
      //       counts[arr[i]] = 1;
      //     } else {
      //       return true;
      //     }
      //   }
      //   return false;
      // }

      // let datas = this.form.courses.reduce((acc, row) => {
      //   acc.push(row.courseId);
      //   return acc;
      // }, []);

      // if (hasDuplicates(datas)) {
      //   this.$store.dispatch('general/showErrorNotification', { message: 'Course Duplicate , please change' });
      // } else {
      this.loading = true;

      this.$store
        .dispatch(`Analytical/useTemplateStudent`, { ...this.form })
        .then(() =>
          this.$router.push({
            name: 'UseTemplateStudentSuccess'
          })
        )
        .finally(() => (this.loading = false));
      // }
    },
    back() {
      this.$router.push({ name: 'AnalyticStudentListID', params: { idSidebar: 4 } });
    }
  },
  created() {
    this.getData();
    this.getClass();
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
